<table>
    <thead>
        <tr>
            <th tuiTh rowspan="2">Type de viste</th>
            <th tuiTh rowspan="2">Date de visite</th>
            <th tuiTh colspan="4">Données</th>
            <th tuiTh rowspan="2">Commentaire</th>
            <th tuiTh rowspan="2">Compte rendu</th>
            <th tuiTh rowspan="2">Rapport machine</th>
        </tr>
        <tr>
            @if(format && (format == 'O2' || format == "O2 LI")){
            <th tuiTh>Déamb</th>
            <th tuiTh>OBS</th>
            <th tuiTh>Débit (R - E)</th>
            <th tuiTh>Durée</th>
            } @else {
            @if(format == 'VENTI'){
            <th tuiTh>VT</th>
            } @else {
            <th tuiTh>P90/95</th>
            }
            <th tuiTh>OBS</th>
            <th tuiTh>IAHR</th>
            <th tuiTh>Fuites</th>
            }
        </tr>
    </thead>
    <tbody>
        @for (intervention of interventionList ; track intervention.id) {
        <app-intervention-row [intervention]="intervention" [format]="format" />
        }@empty{
        @if(format){
        <app-intervention-row [format]="format" />
        <app-intervention-row [format]="format" />
        <app-intervention-row [format]="format" />
        <app-intervention-row [format]="format" />
        <app-intervention-row [format]="format" />
        } @else {
        <app-intervention-row />
        <app-intervention-row />
        <app-intervention-row />
        <app-intervention-row />
        <app-intervention-row />
        }
        }
    </tbody>
</table>
